import React, { useEffect, useState } from 'react';
import DropDown from '../../../../../components/DropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faSquareMinus } from '@fortawesome/pro-solid-svg-icons';
import { faClipboardList, faPlus, faCaretUp, faCaretDown, faQuestionCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useGetAllPublicAssignmentsMutation } from '../../../../../features/authentication/publicAssignmentApiSlice';
import { useParams } from 'react-router';
import CustomToast from '../../../../../components/Toast';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropertiesModal from '../../../../assignments/components/PropertiesModal';
import { useGetPublicAssignmentPropertiesMutation } from '../../../../../features/authentication/authApiSlice';
import FilterCriteria from '../components/filterCriteria/filterCriteria';
import QuestionTypes from '../../../../../enums/questionTypes';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import InfiniteScroll from '../../../../../components/InfiniteScroll/InfiniteScroll';
import { useGetPublicAssignmentMutation, useUpdatePublicAssignmentMutation } from '../../../../../features/authentication/persistApiSlice';
import ActivityTypes from '../../../../../enums/activityTypes';

const PublicAssignments = ({ courses, setSelectedAssignmentId, setShowResults, activityType, setActivityName }) => {
  const [openFilterCriteria, setOpenFilterCriteria] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(-1);
  const [mCValue, setMCValue] = useState(0);
  const [fIValue, setFIValue] = useState(0);
  const [cRValue, setCRValue] = useState(0);
  const [showArchived, setShowArchived] = useState(false);
  const [openPublicAssignmentsList, setOpenPublicAssignmentsList] = useState(false);
  const [isLoadingAssignments, setIsLoadingAssignments] = useState(true);
  const [publicAssignments, setPublicAssignments] = useState([]);
  const [isLoadingAssignmentProperties, setIsLoadingAssignmentProperties] = useState(false);
  const [openAssignmentProperties, setOpenAssignmentProperties] = useState(false);
  const [selectedAssignmentName, setSelectedAssignmentName] = useState('');
  const [assignmentProperties, setAssignmentProperties] = useState([]);
  const [sortId, setSortId] = useState('assignmentName');
  const [isAscending, setIsAscending] = useState(true);
  const [noOfAssignments, setNoOfAssignments] = useState(0);
  const [isAtTop, setIsAtTop] = useState(false);
  const [selectedPropertiesAssignmentId, setSelectedPropertiesAssignmentId] = useState(0);
  const [persistLoad, setPersistLoad] = useState(false);
  const [nextCall, setNextCall] = useState(true);
  const [skipValue, setSkipValue] = useState(0);
  const [scrollAssignmentsList, setScrollAssignmentsList] = useState([]);

  const limit = 30;
  const { assignmentId } = useParams();

  const [getPublicAssignments] = useGetAllPublicAssignmentsMutation();
  const [getPublicAssignmentProperties] = useGetPublicAssignmentPropertiesMutation();
  const [getPersist] = useGetPublicAssignmentMutation();
  const [updatePersist] = useUpdatePublicAssignmentMutation();

  useEffect(() => {
    setOpenPublicAssignmentsList(true);
    handleGetPersist();
  }, []);

  useEffect(() => {
    if(persistLoad)
    {
      setSelectedAssignmentId(0);
      setShowResults(false);
      setOpenPublicAssignmentsList(true);
      setScrollAssignmentsList([]);
      setIsLoadingAssignments(true);
      getPublicAssignmentsAsync(0, limit);
      handleUpdatePersist();

      setIsAtTop(false);
      setNextCall(false);
      setSkipValue(0);
    }
  }, [selectedCourseId, mCValue, fIValue, cRValue, showArchived, persistLoad]);

  const handleGetPersist = async() => {
    var response = await getPersist().unwrap();

    setSelectedCourseId(response.courseId);
    setShowArchived(response.archived);
    setMCValue(response.qTypes?.find(x => x.qType === QuestionTypes.MC)?.value);
    setFIValue(response.qTypes?.find(x => x.qType === QuestionTypes.FillIn)?.value);
    setCRValue(response.qTypes?.find(x => x.qType === QuestionTypes.CR)?.value);

    setPersistLoad(true);
  };

  const handleUpdatePersist = async() => {
    const options = {
      courseId: selectedCourseId,
      archived: showArchived,
      qTypes: [
        {
          'qType': QuestionTypes.MC,
          'value': mCValue
        },
        {
          'qType': QuestionTypes.FillIn,
          'value': fIValue
        },
        {
          'qType': QuestionTypes.CR,
          'value': cRValue
        }
      ]
    };

    await updatePersist(options);
  };

  const getPublicAssignmentsAsync = async (skip, take, isScrolling, sortColumn, sortDirection) => { 
    const options = {
      skip: skip,
      take: take,
      body: { 
        courseId: selectedCourseId,
        questionType: [
          {
            'qType': QuestionTypes.MC,
            'value': mCValue
          },
          {
            'qType': QuestionTypes.FillIn,
            'value': fIValue
          },
          {
            'qType': QuestionTypes.CR,
            'value': cRValue
          }
        ],
        
        archived: showArchived,
        sortColumn : sortColumn ? sortColumn : sortId,
        sortDirection : sortDirection ? sortDirection : (isAscending ? 'ASC' : 'DESC'),
        activity: parseInt(activityType)
      }
    };

    try {
      var response = await getPublicAssignments(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
      else {
        if (assignmentId) {
          var assignmentList = response.data.data.filter(x => x.assignmentId != assignmentId);
          response = { ...response, data: { ...response.data, data: assignmentList } };
        }

        let updatedAssignmentList = response.data.data;
        setScrollAssignmentsList(updatedAssignmentList);
        if(response.data.data.length < limit && isScrolling)
        {
          updatedAssignmentList = [...scrollAssignmentsList, ...updatedAssignmentList]; 
          updatedAssignmentList = updatedAssignmentList.slice(response.data.data.length);
        }
        setPublicAssignments(updatedAssignmentList);
        setNoOfAssignments(response.data.total);
        setIsLoadingAssignments(false);
      }
    } catch (error) {
      console.log(error);
    }
    setOpenPublicAssignmentsList(true);
  };

  const getPublicAssignmentPropertiesAsync = async (assignmentId) => {
    if (!isLoadingAssignmentProperties) {
      setIsLoadingAssignmentProperties(true);
      try {
        const option = {
          assignmentId: assignmentId
        };
        const assignmentsProperties = await getPublicAssignmentProperties(option);
        if (assignmentsProperties.error) {
          CustomToast(assignmentsProperties.error.data.error, 'error');
        }
        else {
          setAssignmentProperties(assignmentsProperties.data);
        }
        setIsLoadingAssignmentProperties(false);
      } catch (error) {
        setIsLoadingAssignmentProperties(false);
        console.log(error);
      }
    }
  };

  const sortButtons = (currentSortId) => {
    return <button className="assignment-sort-btn sort-btn row p-1 mt-2">
      <FontAwesomeIcon icon={faCaretUp} className={`${sortId === currentSortId && isAscending ? 'enabled-caret' : ''}`} />
      <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === currentSortId && !isAscending ? 'enabled-caret' : ''}`} />
    </button>;
  };

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);
    setIsAscending(sortAsc);
    getPublicAssignmentsAsync(0, limit, false, currentSortId, sortAsc ? 'ASC' : 'DESC');
  };

  const handleColSpan = () => {
    let colSpan = 7;
    if(selectedCourseId != -1)
      colSpan = colSpan-1;
    if(mCValue == -1)
      colSpan = colSpan-1;
    if(fIValue == -1)
      colSpan = colSpan-1;
    if(cRValue == -1)
      colSpan = colSpan-1;

    return colSpan;
  };  

  return (
    <>
      <div className='d-flex flex-row gap-4 mb-3'>
        <div className='d-flex gap-3 w-100 flex-row align-items-center justify-content-between'>
          <div className='d-flex flex-column w-25'>
            <DropDown
              key='dropDownCourse'
              label="Course"
              labelClassName="fw-500 mb-0 pb-1"
              value={courses}
              onChangeHandler={(e) => setSelectedCourseId(parseInt(e.target.value))}
              selectedValue={selectedCourseId}
            />
          </div>
          {activityType == ActivityTypes.Assignment && 
          <div className='d-flex align-items-center align-self-end fw-500 text-castleOrange cursor-pointer'
            onClick={() => setOpenFilterCriteria(!openFilterCriteria)}>
            <span>Filter Criteria</span>
            <FontAwesomeIcon className='fs-6 ms-2' icon={openFilterCriteria ? faSquareMinus : faSquarePlus} />
          </div>
          }
        </div>
      </div>
      {openFilterCriteria &&
        <FilterCriteria
          setMCValue={setMCValue}
          mCValue={mCValue}
          setFIValue={setFIValue}
          fIValue={fIValue}
          setCRValue={setCRValue}
          cRValue={cRValue}
          displayShowArchived={true}
          showArchived={showArchived}
          setShowArchived={setShowArchived}
        />
      }
      {openPublicAssignmentsList &&
        <div className='mt-3'>
          <div className='pb-3'>
            <div className='cursor-none d-inline'>
              Click
              <button
                id={'plusBtn'}
                className="btn grid-icon-btn success-icon-btn mx-2">
                <FontAwesomeIcon icon={faPlus} />
              </button>
              icon to add selected {activityType == ActivityTypes.Assignment ? 'questions' : 'vocabularies'} into your {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcards'}
              {activityType == ActivityTypes.Assignment && 
              <> or
                <button
                  id={'viewBtn'}
                  className="btn grid-icon-btn info-icon-btn mx-2">
                  <FontAwesomeIcon icon={faClipboardList} />
                </button>
              icon to view the selected assignment properties.
              </>
              }
            </div>
            {activityType == ActivityTypes.Assignment && 
            <OverlayTrigger
              key="image-overlay"
              placement="top"
              overlay={
                <Tooltip className="image-info-tooltip">
                  <div>
                    <p>This Public Assignment has been designated as a Benchmark. Benchmark assignments can only contain the questions from the public assignment. If you already have questions in your assignment, the Benchmark is marked NOT AVAILABLE.</p>
                    <p>When importing questions from a Benchmark, you have to import all the questions and will not be able to delete or add additional questions to the assignment.</p>
                  </div>
                </Tooltip>
              }>
              <FontAwesomeIcon icon={faQuestionCircle} className="align-baseline ms-2 clr-fa-circle-question fs-6 align-self-center cursor-pointer" />
            </OverlayTrigger>
            }
          </div>
          <InfiniteScroll
            limit={limit}
            totalData={noOfAssignments}
            getData={getPublicAssignmentsAsync}
            setIsAtTop={setIsAtTop}
            nextCall={nextCall}
            setNextCall={setNextCall}
            skipValue={skipValue}
            setSkipValue={setSkipValue}>
            <table className='table'>
              {publicAssignments.length > 0 && !isLoadingAssignments ? (
                <>
                  <thead className='thead-light align-middle'>
                    <tr>
                      <th id='assignmentName' scope="col" className='fw-medium min-w-400' onClick={(e) => handleSort(e.currentTarget.id)}>
                        {activityType == ActivityTypes.Assignment ? 'Assignment Name' : 'Flashcard Name'}
                        {sortButtons('assignmentName')}
                      </th>
                      {selectedCourseId === -1 &&
                        <th id='courseName' scope="col" className='fw-medium' onClick={(e) => handleSort(e.currentTarget.id)}>
                          Course
                          {sortButtons('courseName')}
                        </th>}
                      <th id='ownerName' scope="col" className='fw-medium'>
                        Owner
                      </th>
                      {activityType == ActivityTypes.Assignment && 
                    <>
                      {mCValue != -1 &&
                        <th id='mcCount' scope="col" className='fw-medium min-w-160' onClick={(e) => handleSort(e.currentTarget.id)}>
                          MC Count
                          {sortButtons('mcCount')}
                        </th>
                      }
                      {fIValue != -1 &&
                        <th id='fiCount' scope="col" className='fw-medium min-w-160' onClick={(e) => handleSort(e.currentTarget.id)}>
                          FI Count
                          {sortButtons('fiCount')}
                        </th>
                      }
                      {cRValue != -1 &&
                        <th id='crCount' scope="col" className='fw-medium min-w-160' onClick={(e) => handleSort(e.currentTarget.id)}>
                          CR Count
                          {sortButtons('crCount')}
                        </th>
                      }
                    </>}
                      {activityType == ActivityTypes.FlashCard && 
                        <th id='vocabularyCount' scope="col" className='fw-medium min-w-160' onClick={(e) => handleSort(e.currentTarget.id)}>
                          Vocabulary Count
                          {sortButtons('vocabularyCount')}
                        </th>
                      }
                      <th>
                        {'   '}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isAtTop && nextCall && (
                      <tr>
                        <td colSpan={handleColSpan()}>
                          <div className='scroll-spinner mt-3 d-flex align-item-center justify-content-center'>
                            <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'>Load More</span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {publicAssignments?.map((item, index) => (
                      <>
                        <tr key={item.assignmentId}>
                          <td className='w-min-max-250 text-truncate'>
                            {item.assignmentName}
                            <span className='text-danger'>{item.archived == true && ' (Archived)'}</span>
                          </td>
                          {selectedCourseId === -1 && <td>{item.courseName}</td>}
                          <td>{item.ownerName}</td>
                          {activityType == ActivityTypes.Assignment && 
                          <>
                            {mCValue != -1 && <td>{item.mcCount}</td>}
                            {fIValue != -1 && <td>{item.fiCount}</td>}
                            {cRValue != -1 && <td>{item.crCount}</td>}
                          </>}
                          {activityType == ActivityTypes.FlashCard && 
                           <td>{item.vocabularyCount}</td>
                          }
                                                    
                          <td>
                            <div className='d-flex justify-content-center align-items-center gap-2'>
                              {activityType == ActivityTypes.Assignment && 
                              <OverlayTrigger
                                key={`viewPropertiesToolTip${item.assignmentId}`}
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip">View Properties</Tooltip>}>
                                <button
                                  id={'viewPropties' + index}
                                  className='btn grid-icon-btn info-icon-btn'
                                  onClick={() => { getPublicAssignmentPropertiesAsync(item.assignmentId); setSelectedPropertiesAssignmentId(item.assignmentId); setSelectedAssignmentName(item.assignmentName); setOpenAssignmentProperties(true); }}
                                >
                                  <FontAwesomeIcon icon={faClipboardList} />
                                </button>
                              </OverlayTrigger>
                              }
                              <OverlayTrigger
                                key={`addQuestionToolTip${item.assignmentId}`}
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip">{item.options != 0 ? 'BenchMark - NOT AVAILABLE' : `Add ${activityType == ActivityTypes.Assignment ? 'Questions' : 'Vocabularies'} to ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`}</Tooltip>}>
                                <div>
                                  <button
                                    id={'addQuestions' + index}
                                    className={`btn grid-icon-btn ${item.options != 0 ? 'primary-icon-btn' : 'success-icon-btn'}`}
                                    onClick={async () => {
                                      setSelectedAssignmentName(item.assignmentName);
                                      await setSelectedAssignmentId(item.assignmentId);
                                      setOpenPublicAssignmentsList(false);
                                      setOpenFilterCriteria(false);
                                      setActivityName(item.assignmentName);
                                    }}
                                    disabled={item.options != 0}>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </button>
                                </div>
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </>
              ) : isLoadingAssignments ? (
                <>
                  <TableSkeleton
                    colCount={5}
                    rowCount={4}
                  />
                </>
              ) :
                <p className='text-danger'>There are no Public {activityType == ActivityTypes.Assignment ? 'Assignments' : 'Flashcards'} available.</p>
              }
            </table>
          </InfiniteScroll>
        </div>
      }
      {openAssignmentProperties &&
        <PropertiesModal
          title={selectedAssignmentName}
          properties={assignmentProperties}
          isLoading={isLoadingAssignmentProperties}
          openProperties={openAssignmentProperties}
          setOpenProperties={setOpenAssignmentProperties}
          assignmentId={selectedPropertiesAssignmentId}
          isPublicAssignment={true}
        />
      }
    </>
  );
};

PublicAssignments.propTypes = {
  courses: PropTypes.array,
  setSelectedAssignmentId: PropTypes.func,
  setShowResults: PropTypes.func,
  activityType: PropTypes.number,
  setActivityName: PropTypes.func
};

export default PublicAssignments;
